import { render, staticRenderFns } from "./VircosCalendar.vue?vue&type=template&id=bd8f405c&scoped=true&"
import script from "./VircosCalendar.vue?vue&type=script&lang=js&"
export * from "./VircosCalendar.vue?vue&type=script&lang=js&"
import style0 from "./VircosCalendar.vue?vue&type=style&index=0&id=bd8f405c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f405c",
  null
  
)

export default component.exports